import React from 'react';
import { storiesOf } from '@storybook/react';
import FinancialFilterModal from './FinancialFilterModal';
import { action } from '@storybook/addon-actions';

storiesOf('Advanced Search/Result Form/Modals', module)
  .add('FinancialFilterModal', () => (
    <FinancialFilterModal
      show
      onClose={() => null}
      onSave={action('submitAdvancedSearch')}
      filter={filter}
    />
  ));

const filter = {};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/FinancialFilterModal.stories.jsx